import ImageVO, {ImageSize} from "../../../ts/common/ImageVO";
import React from "react";
import ImageView from "./ImageView";

interface IProps
{
    imageVO: ImageVO;
    size: ImageSize;
    width?: number;
    height?: number;
    alt?: string;
    caption?: string;
}

const ImageVOView = (props: IProps) =>
{
    const imageVO = props.imageVO;
    const imageSizeVO = imageVO.size[props.size] ?? null;
    if(!imageSizeVO){
        return <></>;
    }


    return <ImageView
        url={imageSizeVO.url}
        width={props.width ?? imageSizeVO.width}
        height={props.height ?? imageSizeVO.width}
        alt={props.alt ?? imageVO.alt}
        caption={props.caption ?? imageVO.caption}
    />
}
export default ImageVOView;